import { getPriceByType } from '@mfs/client/listings-client/components/Listings/SBSHelpers/SBSHelpers'

const removeCheapestBadgeFromNonExpressDeals = (listings) => {
  return listings.map((listing) => {
    if (!listing.isExpressDeal && listing.slices) {
      const updatedSlices = listing.slices.map((slice, i) =>
        i === 0
          ? {
              ...slice,
              merchandisingBadges: (slice.merchandisingBadges || []).filter(
                (b) => b.title?.toLowerCase() !== 'cheapest'
              ),
            }
          : slice
      )
      return { ...listing, slices: updatedSlices }
    }
    return listing
  })
}
const updateListingsWithCheapestBadge = ({ response, isRecommendedListings }) => {
  const listingsMetaData = response?.listingsMetaData || {}
  try {
    let cheapestBadgeAdded = false

    const listingsWithBadge = response.listings.map((listing) => {
      const avgPrice = getPriceByType({ prices: listing.fareBrands?.[0]?.price, type: 'AVG_PRICE' })?.amount
      const isExpressDealCheaper = avgPrice && listingsMetaData?.minimumRetailPrice > avgPrice

      if (!listing.isExpressDeal && isRecommendedListings && isExpressDealCheaper) {
        return removeCheapestBadgeFromNonExpressDeals(listing)
      }

      if (listing.isExpressDeal) {
        if (isExpressDealCheaper) {
          cheapestBadgeAdded = true
          return {
            ...listing,
            merchandisings: [
              ...(listing.merchandisings || []),
              { colorScheme: 'successDarkOnLight', value: 'Cheapest' },
            ],
          }
        } else {
          return {
            ...listing,
            merchandisings: [
              ...(listing.merchandisings || []),
              { colorScheme: 'successDarkOnLight', value: 'Budget Friendly' },
            ],
          }
        }
      }

      return listing
    })

    if (!cheapestBadgeAdded) return listingsWithBadge

    return removeCheapestBadgeFromNonExpressDeals(listingsWithBadge)
  } catch (error) {
    return response.listings || []
  }
}

export default updateListingsWithCheapestBadge
